/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleRentalSummary } from './VehicleRentalSummary';
import {
    VehicleRentalSummaryFromJSON,
    VehicleRentalSummaryFromJSONTyped,
    VehicleRentalSummaryToJSON,
    VehicleRentalSummaryToJSONTyped,
} from './VehicleRentalSummary';
import type { VehicleRental } from './VehicleRental';
import {
    VehicleRentalFromJSON,
    VehicleRentalFromJSONTyped,
    VehicleRentalToJSON,
    VehicleRentalToJSONTyped,
} from './VehicleRental';

/**
 * 
 * @export
 * @interface VehicleRentalReservation
 */
export interface VehicleRentalReservation {
    /**
     * 
     * @type {VehicleRentalSummary}
     * @memberof VehicleRentalReservation
     */
    summary?: VehicleRentalSummary;
    /**
     * 
     * @type {VehicleRental}
     * @memberof VehicleRentalReservation
     */
    reservation?: VehicleRental;
}

/**
 * Check if a given object implements the VehicleRentalReservation interface.
 */
export function instanceOfVehicleRentalReservation(value: object): value is VehicleRentalReservation {
    return true;
}

export function VehicleRentalReservationFromJSON(json: any): VehicleRentalReservation {
    return VehicleRentalReservationFromJSONTyped(json, false);
}

export function VehicleRentalReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRentalReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'summary': json['summary'] == null ? undefined : VehicleRentalSummaryFromJSON(json['summary']),
        'reservation': json['reservation'] == null ? undefined : VehicleRentalFromJSON(json['reservation']),
    };
}

export function VehicleRentalReservationToJSON(json: any): VehicleRentalReservation {
    return VehicleRentalReservationToJSONTyped(json, false);
}

export function VehicleRentalReservationToJSONTyped(value?: VehicleRentalReservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'summary': VehicleRentalSummaryToJSON(value['summary']),
        'reservation': VehicleRentalToJSON(value['reservation']),
    };
}

